import { render } from "./errorModal.vue?vue&type=template&id=0b1f3d31&scoped=true&lang=html"
import script from "./errorModal.vue?vue&type=script&lang=js"
export * from "./errorModal.vue?vue&type=script&lang=js"

import "./errorModal.vue?vue&type=style&index=0&id=0b1f3d31&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1f3d31"]])

export default __exports__